<template>
  <div class="conferencePage">
    <div class="banner">
      <img src="../assets/Conference/banner.png" alt="">
    </div>
    <div class="conferenceContent">
      <div class="serviceType">
        <h2>服务会议类型</h2>
       <div class="english">— TYPES OF SERVICE MEETINGS —</div>
       <div class="serviceTypeC">
         <ul class="clearfix">
         	<li v-for="(type,index) in serviceTypeList" :key="index">
            <img :src="type.imgUrl" alt="">
            <p>{{type.name}}</p>
          </li>
         </ul>
       </div>
      </div>
      <div class="conferenceServices">
        <h2>一站式会议服务</h2>
        <div class="english">— ONE-STOP CONFERENCE SERVICES —</div>
        <div class="conferenceServicesC">
          <ul class="clearfix">
          	<li v-for="(list,index) in serveList" :key="index">
              <img :src="list.imgUrl" alt="">
              <p>{{list.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="servicesAdvantage">
        <h2>会议服务优势</h2>
        <div class="english">— ADVANTAGES OF CONFERENCE SERVICES —</div>
        <div class="servicesAdvantageC clearfix">
          <ul class="clearfix">
          	<li>
              <p class="advantage">10年大型会议</p>
              <p>服务经验</p>
            </li>
            <li>
              <p class="advantage">数百场大型会议</p>
              <p>服务经验</p>
            </li>
            <li>
              <p class="advantage">10万以上参会人员</p>
              <p>服务经验</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="servicesCase">
        <h2>会议服务案例</h2>
        <div class="english">— CONFERENCE SERVICES CASE —</div>
        <div class="servicesCaseC clearfix">
          <div class="servicesCaseLeft">
            <img src="../assets/Conference/case.png" alt="">
          </div>
          <div class="servicesCaseRight">
            <h3>携手瑞金医院</br>为1000+烧伤科前辈提供会务出行服务</h3>
            <p>客户简介：瑞金医院是上海交通大学医学院附属医院，成立于1907年，三级甲等医院。</p>
            <p>合作背景：为了纪念瑞金医院抢救邱财康成功60周年，2018年5月4日-6日，瑞金医院主办首届广慈烧伤论坛，此次论坛特邀请了当年亲历邱财康抢救的老同志及各界烧伤科前辈，人数达1000以上。瑞金医院将此次会议的行程安排、会场搭建、机票预订、住宿安排、接送机等环节全权交给上海程多多电子商务有限公司负责。</p>
            <p>项目介绍：基于参会人员年龄较高的特殊性，上海程多多电子商务有限公司为此次论坛配置了具有9年以上经验的会务出行专业团队，对年龄较大前辈派专人搀扶，确保每个环节安全周到。</p>
            <p>项目成果：上海程多多电子商务有限公司此次一站式会务出行服务，得到瑞金医院高度认可，让烧伤科前辈们体验到宾至如归的会务出行服务，助力此次会议圆满召开。</p>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<script>
  export default {
    name: 'Conference',
    data() {
      return {
        serviceTypeList:[
          {
            imgUrl:require('../assets/Conference/1.png'),
            name:'企业年会'
          },
          {
            imgUrl:require('../assets/Conference/2.png'),
            name:'新品发布会'
          },
          {
            imgUrl:require('../assets/Conference/3.png'),
            name:'行业峰会'
          },
          {
            imgUrl:require('../assets/Conference/4.png'),
            name:'学术会议'
          }
        ],
        serveList:[
          {
            imgUrl:require('../assets/Conference/serve1.png'),
            name:'票务预订'
          },
          {
            imgUrl:require('../assets/Conference/serve2.png'),
            name:'酒店住宿'
          },
          {
            imgUrl:require('../assets/Conference/serve3.png'),
            name:'接送机'
          },
          {
            imgUrl:require('../assets/Conference/serve4.png'),
            name:'会场布置'
          },
          {
            imgUrl:require('../assets/Conference/serve5.png'),
            name:'会议搭建'
          },

        ]
      }
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  @import "../css/Conference.less";
</style>



// WEBPACK FOOTER //
// src/pages/Conference.vue